import SubTitle from "../SubTitle";
import {AiOutlineGithub} from "react-icons/ai";
import {BiLinkExternal} from "react-icons/bi";
import Popper from "../Poper";
import Animate from "../Animate";

const PortfolioCard = ({work, index, total}) => {

  return (
      <div key={index} className={`${index + 1 < total ? 'mt-10 mb-32' : ''} flex flex-col md:flex-row align-middle ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`}>
        <div className={'flex-1 md:mx-4'}>
          <SubTitle
              title={work.date ? work.name + ' - ( ' + work.date + ' )' : work.name}
              addClass={'leading-none'}
          />
          <Animate direction='up' duration={0.4} delay={0.1} distance={60} scrollTriggerStart='20% bottom'>
            <div className={'my-2 text-amber-500'}>
              <small><strong>{work.for}</strong></small>
            </div>
            <div className='bg-nfr-color-000 dark:bg-nfr-color-700 font-medium py-2 px-4 shadow-sm transition ease-in-out rounded-lg hover:shadow-lg hover:bg-nfr-color-100 dark:hover:bg-nfr-color-800 duration-500'>
              <div className='text-base'>{work.description}</div>
              <div className='mt-1 flex flex-wrap justify-start align-middle'>
                {work.links && work.links.map((link, l) => (
                    <small key={l} className='mr-2'>
                      <a href={link.url} target='_blank' rel="noreferrer">
                        <Popper title={link.name}>
                          <span className={'text-base text-amber-500 hover:text-black dark:hover:text-white'}>{link.name}</span>{l + 1 < work.links.length ? ',' : ''}
                        </Popper>
                      </a>
                    </small>
                ))}
              </div>
            </div>
            <div className={'my-4'}>
              {work.technologies && work.technologies.map((tech, t) => (
                  <strong key={t} className={'pr-2'}>
                    <small>{tech} {t + 1 < work.technologies.length ? ',' : ''}</small>
                  </strong>
              ))}
            </div>
            <div className='mb-4'>
              {(work.link || work.repository) &&
                  <ul className='space-x-6 flex flex-wrap justify-start align-middle'>
                    {work.link &&
                        <li>
                          <a href={work.link} target='_blank' rel="noreferrer">
                            <Popper title={'Link'}>
                              <BiLinkExternal className={'text-4xl text-amber-500 hover:text-amber-400 duration-200'}/>
                            </Popper>
                          </a>
                        </li>
                    }
                    {work.repository &&
                        <li>
                          <a href={work.repository} target='_blank' rel="noreferrer">
                            <Popper title={'Github'}>
                              <AiOutlineGithub className={'text-4xl text-amber-500 hover:text-amber-400 duration-200'}/>
                            </Popper>
                          </a>
                        </li>
                    }
                  </ul>
              }
            </div>
          </Animate>
        </div>
        <div data-aos='fade-in' data-aos-delay='600' className={`flex-1`}>
          {/*<div ref={imgRef} className={`flex-1 duration-500 ${isReveal?' opacity-100 transform translate-y-0':' opacity-0 transform translate-y-10'}`}>*/}
          {work.photo &&
              <>
                {work.link ? (
                    <a href={work.link} target='_blank' rel="noreferrer" className='imageWithOverlay'>
                      <img
                          src={work.photo}
                          alt={work.name}
                          className={'projectImage rounded-lg shadow-sm transition ease-in-out hover:shadow-none'}
                      />
                      <span className='overlayItem bg-gradient-to-t from-nfr-color-100 to-nfr-color-100/50 dark:from-nfr-color-900 to-nfr-color-900/50'>
                        <BiLinkExternal className={'text-4xl text-nfr-color-900 dark:text-white'}/>
                      </span>
                    </a>
                ) : (
                    <div>
                      <img
                          src={work.photo}
                          alt={work.name}
                          className={'projectImage rounded-lg shadow-sm transition ease-in-out hover:shadow-lg'}
                      />
                    </div>
                )}
              </>
          }
        </div>
      </div>
  )
}

export default PortfolioCard;
